import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=58236c33&scoped=true&"
import script from "./order-detail.vue?vue&type=script&lang=js&"
export * from "./order-detail.vue?vue&type=script&lang=js&"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=58236c33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58236c33",
  null
  
)

export default component.exports